import React, { useState, useEffect } from 'react';
import './styles/globals.css';
import { useScrollPosition, useIntersectionObserver } from './hooks';
import { Navbar, Footer, Background } from './components/layout';
import {
  Hero,
  Problems,
  Services,
  Packages,
  Process,
  FAQ,
  CTA,
} from './components/sections';

const styles = {
  container: {
    position: 'relative',
    minHeight: '100vh',
    backgroundColor: '#080c15',
    color: '#e2e8f0',
    fontFamily: "'DM Sans', sans-serif",
    overflowX: 'hidden',
  },
};

const App = () => {
  const scrollY = useScrollPosition();
  const visibleSections = useIntersectionObserver();
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div style={styles.container}>
      <Background scrollY={scrollY} mousePos={mousePos} />
      <Navbar scrollY={scrollY} />

      <Hero />
      <Problems isVisible={visibleSections['probleem']} />
      <Services isVisible={visibleSections['diensten']} />
      <Packages isVisible={visibleSections['pakketten']} />
      <Process isVisible={visibleSections['proces']} />
      <FAQ isVisible={visibleSections['faq']} />
      <CTA />

      <Footer />
    </div>
  );
};

export default App;
